import React from 'react';

const PaperBackground = () => {
  return (
    <>
      {/* 定義 SVG 濾鏡供全域使用：墨水暈染效果 */}
      <svg width="0" height="0" className="absolute pointer-events-none">
        <defs>
          <filter id="ink-bleed" x="-10%" y="-10%" width="120%" height="120%">
            <feTurbulence type="fractalNoise" baseFrequency="0.05" numOctaves="3" result="noise" />
            <feDisplacementMap in="SourceGraphic" in2="noise" scale="1.5" xChannelSelector="R" yChannelSelector="G" result="displaced" />
            <feGaussianBlur in="displaced" stdDeviation="0.3" result="blurred" />
            <feMerge>
              <feMergeNode in="blurred" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
      </svg>
      
      {/* 底部紙張紋理 */}
      <div className="absolute inset-0 paper-texture pointer-events-none z-0 mix-blend-multiply opacity-70"></div>
      
      {/* 輕微的邊緣暗角，增加氛圍感 */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_30%,rgba(217,205,191,0.15)_100%)] pointer-events-none z-0"></div>
    </>
  );
};

export default PaperBackground;